import React, { useEffect, useState } from "react";
import { makeStyles, createStyles, Theme,withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { getCenters } from "../actions/GenomicsAdminAction";
import { connect } from "react-redux";
import { useRef } from "react";
const useStyles = makeStyles((theme: Theme) =>
createStyles({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "155px",
    textTransform: "capitalize",
  },
  margin: {
    margin: theme.spacing(1),
  },
  table: {
    maxWidth: "100%",
    margin: "auto",
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  start: {
    display: "flex",
    justifyContent: "flex-start",
  },
  end: {
    display: "flex",
    justifyContent: "flex-end",
  },
  gap: {
    fontSize: "14px",
    margin: "0 -40px 0 40px",
  },
  select: {
    margin: "0 0 0 -8px",
    minWidth: "155px",
    width: "100%",
    height: "40px",
  },
  textFieldGap: {
    padding: "0 10px",
  },
  centerIt: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  startIt: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  checkBoxGap: {
    padding: "0 40px",
  },
  formContorlLabel: {
    padding: "0 0 0 25px",
    margin: "0 0 0 15px",
    color: "rgba(0, 0, 0, 0.54)",
  },
  tableContainer: {
    marginTop: "2rem",
    position: "sticky",
    top: "200px",
  },
})
);
const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
const tableRows: any = [
  { centreName: "Centre 1", rateListName: "Ratelist 1" },
  { centreName: "Centre 2", rateListName: "Ratelist 2" },
];
interface Props {
  centreId: any;
  rateListId: any;
  getCenters: any;
  centers: any;
}
const CentreRateList: React.FC<Props> = ({
  getCenters,
  centers,
  centreId,
  rateListId,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [center, setCenter] = useState<any>([]);

  useEffect(() => {
    if (rateListId !== undefined && centreId !== undefined) {
      getCenters(`&id=${centreId}&rate_list=${rateListId}`);
    } else {
      getCenters();
    }
  }, [centreId, rateListId]);
  return (
    <form className={classes.root} style={{ width: "100%", marginTop: 20 }}>
      <Grid container>
        <Grid item xs={12}>
          {/* <Paper style={{ width: "100%" }}> */}
          <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px" }}>
              <Table aria-label="simple table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S. No.</StyledTableCell>
                    <StyledTableCell align="center">Hospital/Doctor Name</StyledTableCell>
                    <StyledTableCell align="center">Rate List Name</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {centers.results &&
                    centers.results.length > 0 &&
                    centers.results?.map((row: any, index: number) => {
                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center">{index + 1}</StyledTableCell>
                          <StyledTableCell align="center">
                            {row?.display_name === null
                              ? row?.name
                              : row?.display_name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row?.ratelist.length > 0 &&
                              row?.ratelist.map((val: any, index1: any) => {
                                return (
                                  <span>
                                    {index1 > 0 ? ", " : ""}
                                    {val?.name}
                                  </span>
                                );
                              })}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          {/* </Paper> */}
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state: any) => ({
  centers: state.GenomicsAdminReducer.centers,
});

export default connect(mapStateToProps, {
  getCenters,
})(CentreRateList);
